const PUBLISH_INFOGRAPH_API = '/multipage/infographic/publish';

interface PublishInfographResponse {
  status: 'ok' | 'fail';
  message?: string;
}

// This endpoint is only accessible by free users to publish the infograph
// Unlike E1, E2 currently (23.13.0) only has /pl page, and it's publicly accessible
// After publishing, the /pl would be available for them (though it's gated in Share Panel for free users)
// As unpublish wouldn't make /pl page unaccessible, we don't need to add unpublish api endpoint
export const publishInfograph = async (infographId: string, title: string) => {
  const postData = {
    infographic: infographId,
    title,
  };
  const response = await fetch(PUBLISH_INFOGRAPH_API, {
    body: JSON.stringify(postData),
    method: 'post',
  });

  const json = (await response.json()) as PublishInfographResponse;
  if (!json || json.status !== 'ok') throw new Error(json?.message ?? 'Unknown error');
  return json;
};
